import * as React from 'react'

import { Checkbox, Label } from '../../../components'
import { useForceUpdate } from '../../../utils/force-update'
import { useChartLayoutGlobalModel } from '../chart-layout-model'
import { handleChartAttributeChange, handleQuoteAttributeChange } from './model-manipulation'

export function ChartExtendedHoursToggle() {
  const { forceUpdate } = useForceUpdate()
  const { chartLayoutModel } = useChartLayoutGlobalModel()
  const quote = chartLayoutModel?.charts().first()?.quote()

  const onExtendedHoursChange = React.useCallback(
    ({ extendedHoursType, checked }: { extendedHoursType: 'premarket' | 'aftermarket'; checked: boolean }) => {
      if (chartLayoutModel) {
        handleChartAttributeChange({ attributes: { [extendedHoursType]: checked }, chartLayoutModel })
        handleQuoteAttributeChange({ attributes: { [extendedHoursType]: checked }, chartLayoutModel })
        forceUpdate()
      }
    },
    [forceUpdate, chartLayoutModel]
  )

  if (!chartLayoutModel) return null

  return (
    <>
      <Label title="Show Extended Hours" />
      <div className="flex flex-col items-start">
        <Checkbox
          className="cursor-pointer"
          checked={!!quote?.premarket}
          data-testid="chart-settings-extended-hours-premarket"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onExtendedHoursChange({ extendedHoursType: 'premarket', checked: e.target.checked })
          }
        >
          Pre-market
        </Checkbox>
        <Checkbox
          className="cursor-pointer"
          checked={!!quote?.aftermarket}
          data-testid="chart-settings-extended-hours-aftermarket"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onExtendedHoursChange({ extendedHoursType: 'aftermarket', checked: e.target.checked })
          }
        >
          After-market
        </Checkbox>
      </div>
    </>
  )
}
